var map = {
	"./core/Drawer.vue": "41c0",
	"./core/Footer.vue": "7a74",
	"./core/Login.vue": "3656",
	"./core/View.vue": "9306",
	"./formace/agregarqr.vue": "a046",
	"./formace/centros.vue": "328a",
	"./formace/empleos.vue": "4b12",
	"./formace/enlistar.vue": "78ad",
	"./formace/grupos.vue": "d83c",
	"./formace/personas.vue": "c5bc",
	"./formace/servicios.vue": "9144",
	"./formace/servvet.vue": "d3f2",
	"./formace/usuarios.vue": "bea4",
	"./helper/Offset.vue": "c6cc",
	"./material/Card.vue": "e3a9",
	"./material/ChartCard.vue": "78d5",
	"./material/Notification.vue": "9d6c",
	"./material/StatsCard.vue": "42e7",
	"./other/Detalles.vue": "8f9e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ffe0";